import { L10n } from '../L10n/L10n';
import { IGroupInfo } from '../models/IGroupInfo';
import { ISiteUserInfo } from '../models/ISiteUserInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { SiteUsers } from '../resources/SiteUsers';
import { IResult } from '../ServerApi/types/IResponse';
import { ConfirmActionDialog } from './ConfirmActionDialog';
import { GroupMembershipUpdateActionNotification } from './UserActionNotification';

export class RemoveUsersFromGroupAction {

  public static $inject = ['$translate',
                           'ConfirmActionDialog',
                           'SiteUsers',
                           'GroupMembershipUpdateActionNotification'];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private ConfirmActionDialog: ConfirmActionDialog,
    private SiteUsers: SiteUsers,
    private groupMembershipUpdateActionNotification: GroupMembershipUpdateActionNotification) { }

  public showRemoveUsersFromGroupDialog(
    groupUsers: Set<ISiteUserInfo>,
    group: IGroupInfo): ng.IPromise<any> {

    const dialogBody = this.$translate.instant('confirmRemoveUsersFromGroup', {
      USER_NAME: L10n.elideIfLong(groupUsers.first().displayName),
      USER_COUNT: groupUsers.size(),
      GROUP_NAME: L10n.elideIfLong(group.name)
    }, L10n.Interpolations.Count);

    const dialogInstance = this.ConfirmActionDialog.open({
      title: this.$translate.instant('remove'),
      bodyText: dialogBody,
      actionName: this.$translate.instant('confirmRemoveButton', {
        ITEM_COUNT: groupUsers.size()
      }, L10n.Interpolations.Count),
      isDeleteAction: true,
      action: () => this.SiteUsers.removeFromGroups(groupUsers.keys(), [ group.id ])
    });

    dialogInstance.result.then((result: IResult) => {

      this.groupMembershipUpdateActionNotification.notify(
        result,
        groupUsers,
        0,
        null,
        1,
        group.name);
    });

    return dialogInstance.result;
  }

}

Module.instance().service('RemoveUsersFromGroupAction', RemoveUsersFromGroupAction);
